<section>
  <p>
    <strong>שם החותם: {{ user.signatureName }}</strong>
  </p>
  <p>
    <strong>תפקיד: {{ user.jobTitle }}</strong>
  </p>
  <p>
    <strong>תאריך: {{ date }}</strong>
  </p>
</section>
<div style="position: absolute; margin-top: -60px; margin-right: 90px">
  <img [src]="user.signature | safe : 'resourceUrl'" />
</div>
